<div class="allteams">Current Team Allowances</div>
<app-allowances-highcharts-container [teamType]="'current-team'"></app-allowances-highcharts-container>
